import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { Box, Grid, IconButton, TextField, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";

export default function OpenNotificationHeader(props) {
  const [currentData, setCurrentData] = React.useState({});

  React.useEffect(() => {
    setCurrentData(props.data);
  }, [props.data]);
  const handleCancel = () => {
    props.setOpen(false);
  };

  const infoItemStyle = {
    mb: 1,
    display: "flex",
  };

  const infoLabelStyle = {
    fontWeight: "500",
    fontSize: "1rem",
    mr: 1,
  };

  const infoValueStyle = {
    fontWeight: "400",
    fontSize: "1rem",
    width: "fit-content",
    display: "inline-block",
    overflowWrap: "break-word",
  };

  const emptyValueStyle = {
    fontStyle: "italic",
    color: "text.secondary",
  };
  const renderInfoItem = (label, value) => (
    <Grid item xs={12} sx={infoItemStyle}>
      <Typography variant="body2" component="span" sx={infoLabelStyle}>
        {label}:
      </Typography>
      <Typography variant="body2" component="span" sx={infoValueStyle}>
        {value ? value : <span style={emptyValueStyle}>—</span>}
      </Typography>
    </Grid>
  );

  return (
    <React.Fragment>
      <Dialog
        open={props.open}
        onClose={handleCancel}
        aria-labelledby="notification-dialog"
        aria-describedby="notification-dialog"
        maxWidth="lg"
      >
        <Box sx={{ position: "relative" }}>
          <Typography
            sx={{
              textAlign: "center",
              py: 3,
              px: 3,
              fontSize: "1.5rem",
              fontWeight: 600,
            }}
          >
            Notification
          </Typography>
          <DialogContent>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 5,
                justifyContent: "center",
                width: 710,
              }}
            >
              <IconButton
                onClick={handleCancel}
                sx={{ position: "absolute", top: 20, right: 20 }}
              >
                <Close />
              </IconButton>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                {renderInfoItem("Date", new Date(currentData.date).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }))}
               
                <Box display={"flex"} gap={1}>
                  <Typography sx={{ fontWeight: 500, fontSize: "1rem" }}>
                    Title:
                  </Typography>
                  <Box
                    display={"flex"}
                    sx={{
                      fontWeight: 500,
                      fontSize: "1rem",
                      flexWrap: "wrap",
                      width: "90%",
                      wordBreak: "break-all",
                    }}
                  >
                    {currentData.title}
                  </Box>
                </Box>
                <TextField
                  multiline
                  readOnly
                  rows={6}
                  sx={{ overflow: "auto", my: 1.5 }}
                  InputProps={{
                    readOnly: true,
                  }}
                  value={currentData.body}
                ></TextField>
              </Box>
            </Box>
          </DialogContent>
        </Box>
      </Dialog>
    </React.Fragment>
  );
}
